import React from 'react';

export default React.createContext({ rootWidth: undefined });
